export enum PropertyTypeEnum {
  DETACHED = "detached",
  SEMI_DETACHED = "semi-detached",
  TERRACED = "terraced",
  FLAT_MAISONETTE = "flat-maisonette",
  OTHER = "other"
}
